import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getDefaultCallsCostsForAccount} from 'src/openapi/admin/apis/CallCostControllerApi';
import {useAppDispatch} from 'src/store/hooks';

import type {PricingModel} from 'src/openapi/admin/models/PricingModel';

type Props = {
    accountId: number,
    pricingModel: PricingModel,
};

export const useDefaultCallCost = ({accountId, pricingModel}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getDefaultCallsCostsForAccount({accountId, pricingModel}),
    ), [accountId, pricingModel, apiDispatch]);

    return useReadOnlyDataHook({
        initValue: [],
        getDispatchAction,
    });
};
